export { default } from './SearchResultsPage';
